exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 1220px) {\n.choose-section .service-text-wrapper[data-v-c712fc60] {\n    max-width: 650px !important;\n}\n}", ""]);

// exports
